"use strict";
// tslint:disable
/**
 * Laravel WebAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SearchGetSortEnum = exports.SearchGetArchivedEnum = exports.SearchGetGradeEnum = exports.SearchGetStateEnum = exports.MyActivityGetArchivedEnum = exports.MyActivityGetStateEnum = exports.MarketApi = void 0;
var runtime = require("../runtime");
var models_1 = require("../models");
/**
 * no description
 */
var MarketApi = /** @class */ (function (_super) {
    __extends(MarketApi, _super);
    function MarketApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * list my activity.
     */
    MarketApi.prototype.myActivityGetRaw = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        queryParameters = {};
                        if (requestParameters.cursor !== undefined) {
                            queryParameters['cursor'] = requestParameters.cursor;
                        }
                        if (requestParameters.state !== undefined) {
                            queryParameters['state'] = requestParameters.state;
                        }
                        if (requestParameters.archived !== undefined) {
                            queryParameters['archived'] = requestParameters.archived;
                        }
                        headerParameters = {};
                        if (this.configuration && this.configuration.apiKey) {
                            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
                        }
                        return [4 /*yield*/, this.request({
                                path: "/my/activity",
                                method: 'GET',
                                headers: headerParameters,
                                query: queryParameters,
                            })];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return models_1.GetMyActivityResponseFromJSON(jsonValue); })];
                }
            });
        });
    };
    /**
     * list my activity.
     */
    MarketApi.prototype.myActivityGet = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.myActivityGetRaw(requestParameters)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * archive offer.
     */
    MarketApi.prototype.offersIdArchivePutRaw = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.id === null || requestParameters.id === undefined) {
                            throw new runtime.RequiredError('id', 'Required parameter requestParameters.id was null or undefined when calling offersIdArchivePut.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        if (this.configuration && this.configuration.apiKey) {
                            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
                        }
                        return [4 /*yield*/, this.request({
                                path: "/offers/{id}/archive".replace("{" + "id" + "}", encodeURIComponent(String(requestParameters.id))),
                                method: 'PUT',
                                headers: headerParameters,
                                query: queryParameters,
                            })];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return models_1.OfferFromJSON(jsonValue); })];
                }
            });
        });
    };
    /**
     * archive offer.
     */
    MarketApi.prototype.offersIdArchivePut = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.offersIdArchivePutRaw(requestParameters)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * get offer chat.
     */
    MarketApi.prototype.offersIdChatGetRaw = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.id === null || requestParameters.id === undefined) {
                            throw new runtime.RequiredError('id', 'Required parameter requestParameters.id was null or undefined when calling offersIdChatGet.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        if (this.configuration && this.configuration.apiKey) {
                            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
                        }
                        return [4 /*yield*/, this.request({
                                path: "/offers/{id}/chat".replace("{" + "id" + "}", encodeURIComponent(String(requestParameters.id))),
                                method: 'GET',
                                headers: headerParameters,
                                query: queryParameters,
                            })];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return models_1.ChatFromJSON(jsonValue); })];
                }
            });
        });
    };
    /**
     * get offer chat.
     */
    MarketApi.prototype.offersIdChatGet = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.offersIdChatGetRaw(requestParameters)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * create offer.
     */
    MarketApi.prototype.offersIdDetailsPutRaw = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.id === null || requestParameters.id === undefined) {
                            throw new runtime.RequiredError('id', 'Required parameter requestParameters.id was null or undefined when calling offersIdDetailsPut.');
                        }
                        if (requestParameters.createOfferRequest === null || requestParameters.createOfferRequest === undefined) {
                            throw new runtime.RequiredError('createOfferRequest', 'Required parameter requestParameters.createOfferRequest was null or undefined when calling offersIdDetailsPut.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        headerParameters['Content-Type'] = 'application/json';
                        if (this.configuration && this.configuration.apiKey) {
                            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
                        }
                        return [4 /*yield*/, this.request({
                                path: "/offers/{id}/details".replace("{" + "id" + "}", encodeURIComponent(String(requestParameters.id))),
                                method: 'PUT',
                                headers: headerParameters,
                                query: queryParameters,
                                body: models_1.CreateOfferRequestToJSON(requestParameters.createOfferRequest),
                            })];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return models_1.OfferFromJSON(jsonValue); })];
                }
            });
        });
    };
    /**
     * create offer.
     */
    MarketApi.prototype.offersIdDetailsPut = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.offersIdDetailsPutRaw(requestParameters)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * upvote offer.
     */
    MarketApi.prototype.offersIdDownvotePutRaw = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.id === null || requestParameters.id === undefined) {
                            throw new runtime.RequiredError('id', 'Required parameter requestParameters.id was null or undefined when calling offersIdDownvotePut.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        if (this.configuration && this.configuration.apiKey) {
                            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
                        }
                        return [4 /*yield*/, this.request({
                                path: "/offers/{id}/downvote".replace("{" + "id" + "}", encodeURIComponent(String(requestParameters.id))),
                                method: 'PUT',
                                headers: headerParameters,
                                query: queryParameters,
                            })];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response)];
                }
            });
        });
    };
    /**
     * upvote offer.
     */
    MarketApi.prototype.offersIdDownvotePut = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.offersIdDownvotePutRaw(requestParameters)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * get offer.
     */
    MarketApi.prototype.offersIdGetRaw = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.id === null || requestParameters.id === undefined) {
                            throw new runtime.RequiredError('id', 'Required parameter requestParameters.id was null or undefined when calling offersIdGet.');
                        }
                        queryParameters = {};
                        if (requestParameters.language !== undefined) {
                            queryParameters['language'] = requestParameters.language;
                        }
                        headerParameters = {};
                        if (this.configuration && this.configuration.apiKey) {
                            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
                        }
                        return [4 /*yield*/, this.request({
                                path: "/offers/{id}".replace("{" + "id" + "}", encodeURIComponent(String(requestParameters.id))),
                                method: 'GET',
                                headers: headerParameters,
                                query: queryParameters,
                            })];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return models_1.OfferFromJSON(jsonValue); })];
                }
            });
        });
    };
    /**
     * get offer.
     */
    MarketApi.prototype.offersIdGet = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.offersIdGetRaw(requestParameters)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * publish offer.
     */
    MarketApi.prototype.offersIdPublishPutRaw = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.id === null || requestParameters.id === undefined) {
                            throw new runtime.RequiredError('id', 'Required parameter requestParameters.id was null or undefined when calling offersIdPublishPut.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        if (this.configuration && this.configuration.apiKey) {
                            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
                        }
                        return [4 /*yield*/, this.request({
                                path: "/offers/{id}/publish".replace("{" + "id" + "}", encodeURIComponent(String(requestParameters.id))),
                                method: 'PUT',
                                headers: headerParameters,
                                query: queryParameters,
                            })];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return models_1.OfferFromJSON(jsonValue); })];
                }
            });
        });
    };
    /**
     * publish offer.
     */
    MarketApi.prototype.offersIdPublishPut = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.offersIdPublishPutRaw(requestParameters)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * create offer reservation.
     */
    MarketApi.prototype.offersIdReservationPostRaw = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.id === null || requestParameters.id === undefined) {
                            throw new runtime.RequiredError('id', 'Required parameter requestParameters.id was null or undefined when calling offersIdReservationPost.');
                        }
                        if (requestParameters.createReservationRequest === null || requestParameters.createReservationRequest === undefined) {
                            throw new runtime.RequiredError('createReservationRequest', 'Required parameter requestParameters.createReservationRequest was null or undefined when calling offersIdReservationPost.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        headerParameters['Content-Type'] = 'application/json';
                        if (this.configuration && this.configuration.apiKey) {
                            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
                        }
                        return [4 /*yield*/, this.request({
                                path: "/offers/{id}/reservation".replace("{" + "id" + "}", encodeURIComponent(String(requestParameters.id))),
                                method: 'POST',
                                headers: headerParameters,
                                query: queryParameters,
                                body: models_1.CreateReservationRequestToJSON(requestParameters.createReservationRequest),
                            })];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response)];
                }
            });
        });
    };
    /**
     * create offer reservation.
     */
    MarketApi.prototype.offersIdReservationPost = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.offersIdReservationPostRaw(requestParameters)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * accept trade.
     */
    MarketApi.prototype.offersIdTradeAcceptPostRaw = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.id === null || requestParameters.id === undefined) {
                            throw new runtime.RequiredError('id', 'Required parameter requestParameters.id was null or undefined when calling offersIdTradeAcceptPost.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        if (this.configuration && this.configuration.apiKey) {
                            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
                        }
                        return [4 /*yield*/, this.request({
                                path: "/offers/{id}/trade/accept".replace("{" + "id" + "}", encodeURIComponent(String(requestParameters.id))),
                                method: 'POST',
                                headers: headerParameters,
                                query: queryParameters,
                            })];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return models_1.OfferFromJSON(jsonValue); })];
                }
            });
        });
    };
    /**
     * accept trade.
     */
    MarketApi.prototype.offersIdTradeAcceptPost = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.offersIdTradeAcceptPostRaw(requestParameters)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * reject trade.
     */
    MarketApi.prototype.offersIdTradeCompletePostRaw = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.id === null || requestParameters.id === undefined) {
                            throw new runtime.RequiredError('id', 'Required parameter requestParameters.id was null or undefined when calling offersIdTradeCompletePost.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        if (this.configuration && this.configuration.apiKey) {
                            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
                        }
                        return [4 /*yield*/, this.request({
                                path: "/offers/{id}/trade/complete".replace("{" + "id" + "}", encodeURIComponent(String(requestParameters.id))),
                                method: 'POST',
                                headers: headerParameters,
                                query: queryParameters,
                            })];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return models_1.OfferFromJSON(jsonValue); })];
                }
            });
        });
    };
    /**
     * reject trade.
     */
    MarketApi.prototype.offersIdTradeCompletePost = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.offersIdTradeCompletePostRaw(requestParameters)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * reject trade.
     */
    MarketApi.prototype.offersIdTradeRejectPostRaw = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.id === null || requestParameters.id === undefined) {
                            throw new runtime.RequiredError('id', 'Required parameter requestParameters.id was null or undefined when calling offersIdTradeRejectPost.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        if (this.configuration && this.configuration.apiKey) {
                            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
                        }
                        return [4 /*yield*/, this.request({
                                path: "/offers/{id}/trade/reject".replace("{" + "id" + "}", encodeURIComponent(String(requestParameters.id))),
                                method: 'POST',
                                headers: headerParameters,
                                query: queryParameters,
                            })];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return models_1.OfferFromJSON(jsonValue); })];
                }
            });
        });
    };
    /**
     * reject trade.
     */
    MarketApi.prototype.offersIdTradeRejectPost = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.offersIdTradeRejectPostRaw(requestParameters)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * unpublish offer.
     */
    MarketApi.prototype.offersIdUnpublishPutRaw = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.id === null || requestParameters.id === undefined) {
                            throw new runtime.RequiredError('id', 'Required parameter requestParameters.id was null or undefined when calling offersIdUnpublishPut.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        if (this.configuration && this.configuration.apiKey) {
                            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
                        }
                        return [4 /*yield*/, this.request({
                                path: "/offers/{id}/unpublish".replace("{" + "id" + "}", encodeURIComponent(String(requestParameters.id))),
                                method: 'PUT',
                                headers: headerParameters,
                                query: queryParameters,
                            })];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return models_1.OfferFromJSON(jsonValue); })];
                }
            });
        });
    };
    /**
     * unpublish offer.
     */
    MarketApi.prototype.offersIdUnpublishPut = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.offersIdUnpublishPutRaw(requestParameters)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * upvote offer.
     */
    MarketApi.prototype.offersIdUpvotePutRaw = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.id === null || requestParameters.id === undefined) {
                            throw new runtime.RequiredError('id', 'Required parameter requestParameters.id was null or undefined when calling offersIdUpvotePut.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        if (this.configuration && this.configuration.apiKey) {
                            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
                        }
                        return [4 /*yield*/, this.request({
                                path: "/offers/{id}/upvote".replace("{" + "id" + "}", encodeURIComponent(String(requestParameters.id))),
                                method: 'PUT',
                                headers: headerParameters,
                                query: queryParameters,
                            })];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response)];
                }
            });
        });
    };
    /**
     * upvote offer.
     */
    MarketApi.prototype.offersIdUpvotePut = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.offersIdUpvotePutRaw(requestParameters)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * create offer.
     */
    MarketApi.prototype.offersPostRaw = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.createOfferRequest === null || requestParameters.createOfferRequest === undefined) {
                            throw new runtime.RequiredError('createOfferRequest', 'Required parameter requestParameters.createOfferRequest was null or undefined when calling offersPost.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        headerParameters['Content-Type'] = 'application/json';
                        if (this.configuration && this.configuration.apiKey) {
                            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
                        }
                        return [4 /*yield*/, this.request({
                                path: "/offers",
                                method: 'POST',
                                headers: headerParameters,
                                query: queryParameters,
                                body: models_1.CreateOfferRequestToJSON(requestParameters.createOfferRequest),
                            })];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return models_1.OfferFromJSON(jsonValue); })];
                }
            });
        });
    };
    /**
     * create offer.
     */
    MarketApi.prototype.offersPost = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.offersPostRaw(requestParameters)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * search offers.
     */
    MarketApi.prototype.searchGetRaw = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        queryParameters = {};
                        if (requestParameters.warehouse !== undefined) {
                            queryParameters['warehouse'] = requestParameters.warehouse;
                        }
                        if (requestParameters.text !== undefined) {
                            queryParameters['text'] = requestParameters.text;
                        }
                        if (requestParameters.language !== undefined) {
                            queryParameters['language'] = requestParameters.language;
                        }
                        if (requestParameters.cursor !== undefined) {
                            queryParameters['cursor'] = requestParameters.cursor;
                        }
                        if (requestParameters.category !== undefined) {
                            queryParameters['category'] = requestParameters.category;
                        }
                        if (requestParameters.state !== undefined) {
                            queryParameters['state'] = requestParameters.state;
                        }
                        if (requestParameters.country !== undefined) {
                            queryParameters['country'] = requestParameters.country;
                        }
                        if (requestParameters.grade !== undefined) {
                            queryParameters['grade'] = requestParameters.grade;
                        }
                        if (requestParameters.archived !== undefined) {
                            queryParameters['archived'] = requestParameters.archived;
                        }
                        if (requestParameters.sort !== undefined) {
                            queryParameters['sort'] = requestParameters.sort;
                        }
                        headerParameters = {};
                        if (this.configuration && this.configuration.apiKey) {
                            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
                        }
                        return [4 /*yield*/, this.request({
                                path: "/search",
                                method: 'GET',
                                headers: headerParameters,
                                query: queryParameters,
                            })];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return models_1.SearchOffersResponseFromJSON(jsonValue); })];
                }
            });
        });
    };
    /**
     * search offers.
     */
    MarketApi.prototype.searchGet = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.searchGetRaw(requestParameters)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    return MarketApi;
}(runtime.BaseAPI));
exports.MarketApi = MarketApi;
/**
    * @export
    * @enum {string}
    */
var MyActivityGetStateEnum;
(function (MyActivityGetStateEnum) {
    MyActivityGetStateEnum["Draft"] = "draft";
    MyActivityGetStateEnum["Published"] = "published";
    MyActivityGetStateEnum["Reserved"] = "reserved";
    MyActivityGetStateEnum["Traded"] = "traded";
})(MyActivityGetStateEnum = exports.MyActivityGetStateEnum || (exports.MyActivityGetStateEnum = {}));
/**
    * @export
    * @enum {string}
    */
var MyActivityGetArchivedEnum;
(function (MyActivityGetArchivedEnum) {
    MyActivityGetArchivedEnum["None"] = "none";
    MyActivityGetArchivedEnum["Include"] = "include";
    MyActivityGetArchivedEnum["Only"] = "only";
})(MyActivityGetArchivedEnum = exports.MyActivityGetArchivedEnum || (exports.MyActivityGetArchivedEnum = {}));
/**
    * @export
    * @enum {string}
    */
var SearchGetStateEnum;
(function (SearchGetStateEnum) {
    SearchGetStateEnum["All"] = "all";
    SearchGetStateEnum["Published"] = "published";
    SearchGetStateEnum["Traded"] = "traded";
})(SearchGetStateEnum = exports.SearchGetStateEnum || (exports.SearchGetStateEnum = {}));
/**
    * @export
    * @enum {string}
    */
var SearchGetGradeEnum;
(function (SearchGetGradeEnum) {
    SearchGetGradeEnum["A"] = "A";
    SearchGetGradeEnum["B"] = "B";
    SearchGetGradeEnum["C"] = "C";
    SearchGetGradeEnum["D"] = "D";
})(SearchGetGradeEnum = exports.SearchGetGradeEnum || (exports.SearchGetGradeEnum = {}));
/**
    * @export
    * @enum {string}
    */
var SearchGetArchivedEnum;
(function (SearchGetArchivedEnum) {
    SearchGetArchivedEnum["None"] = "none";
    SearchGetArchivedEnum["Include"] = "include";
    SearchGetArchivedEnum["Only"] = "only";
})(SearchGetArchivedEnum = exports.SearchGetArchivedEnum || (exports.SearchGetArchivedEnum = {}));
/**
    * @export
    * @enum {string}
    */
var SearchGetSortEnum;
(function (SearchGetSortEnum) {
    SearchGetSortEnum["IdAsc"] = "id_asc";
    SearchGetSortEnum["IdDesc"] = "id_desc";
    SearchGetSortEnum["UpvoteAsc"] = "upvote_asc";
    SearchGetSortEnum["UpvoteDesc"] = "upvote_desc";
})(SearchGetSortEnum = exports.SearchGetSortEnum || (exports.SearchGetSortEnum = {}));
